import Layout from "@/components/feature/Layout";
import SectionHeading from "@/components/base/SectionHeading";
import ArticleCard from "@/components/base/ArticleCard";
import Breadcrumb from "@/components/base/Breadcrumb";
import Reveal from "@/components/base/Reveal";
import { useSeo } from "@/hooks/useSeo";
import { articles } from "@/mocks/articles";
import { SITE } from "@/config/site";

export default function Articles() {
  useSeo({
    title: "抖漫资讯_动态漫画行业观察与追更指南 - 抖漫",
    description: "抖漫资讯频道，汇聚动态漫画行业观察、热门作品推荐、追更技巧与平台动态，助你发现更多好内容。",
    keywords: "抖漫资讯,动态漫画推荐,追更指南,行业观察",
    path: "/articles",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: "抖漫资讯",
        url: `${SITE.baseUrl}/articles`,
        inLanguage: "zh-CN",
      },
    ],
  });

  return (
    <Layout>
      <section className="pt-28 pb-14">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <Reveal>
            <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "全部资讯" }]} />
          </Reveal>

          <Reveal delay={80}>
            <h1 className="font-heading text-3xl md:text-4xl text-foreground-50 mt-4 mb-2">抖漫资讯</h1>
            <p className="text-sm md:text-base text-foreground-500 mb-8">
              行业观察 · 热门推荐 · 追更指南 · 内容动态
            </p>
          </Reveal>

          <Reveal delay={120}>
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
              {articles.map((a) => (
                <ArticleCard key={a.id} article={a} />
              ))}
            </div>
          </Reveal>
        </div>
      </section>
    </Layout>
  );
}